import * as Lodash from 'lodash';
import { IdFuncs } from '../../../../common/core/id/id.funcs';
import { MegaBoardColWire, MegaBoardContentWire, MegaBoardItemWire, MegaBoardRowWire } from './mega-board-content.wire';

function starter(): MegaBoardContentWire {
  return {
    items: [
      {
        id: IdFuncs.generate(6),
        text: 'Row 1',
        items: [],
      },
    ],
  };
}

function addRow(content: MegaBoardContentWire, { row }: { row: Partial<MegaBoardRowWire> }): void {
  row.id = row.id ?? IdFuncs.generate(6);
  row.items = row.items ?? [];
  content.items.push(row as MegaBoardRowWire);
}

function updateRow(content: MegaBoardContentWire, { rowId, row }: { rowId: string; row: Partial<MegaBoardRowWire> }): void {
  const currentRow = content.items.find((r) => r.id === rowId)!;
  Object.assign(currentRow, row);
}

function removeRow(content: MegaBoardContentWire, { rowId }: { rowId: string }): void {
  Lodash.remove(content.items, (r) => r.id === rowId);
}

function addCol(content: MegaBoardContentWire, { rowId, col }: { rowId: string; col: Partial<MegaBoardColWire> }): void {
  const row = content.items.find((r) => r.id === rowId)! as MegaBoardRowWire;
  col.id = col.id ?? IdFuncs.generate(6);
  col.items = col.items ?? [];
  row.items.push(col as MegaBoardColWire);
}

function updateCol(content: MegaBoardContentWire, { rowId, colId, col }: { rowId: string; colId: string; col: Partial<MegaBoardColWire> }): void {
  const row = content.items.find((r) => r.id === rowId)! as MegaBoardRowWire;
  const currentCol = row.items.find((c) => c.id === colId)!;
  Object.assign(currentCol, col);
}

function removeCol(content: MegaBoardContentWire, { rowId, colId }: { rowId: string; colId: string }): void {
  const row = content.items.find((r) => r.id === rowId)! as MegaBoardRowWire;
  Lodash.remove(row.items, (c) => c.id === colId);
}

function moveCol(content: MegaBoardContentWire, { startingColId, endingColId }: { startingColId: string; endingColId: string }): void {
  const startingRow = content.items.find((r) => r.items.map((c) => c.id).includes(startingColId))! as MegaBoardRowWire;
  const endingRow = content.items.find((r) => r.items.map((c) => c.id).includes(endingColId))! as MegaBoardRowWire;

  const startingColIndex = startingRow.items.findIndex((c) => c.id === startingColId);
  const endingColIndex = endingRow.items.findIndex((c) => c.id === endingColId);
  const [startingCol] = startingRow.items.splice(startingColIndex, 1);
  endingRow.items.splice(endingColIndex, 0, startingCol);
}

function addItem(content: MegaBoardContentWire, { rowId, colId, item }: { rowId: string; colId: string; item: Partial<MegaBoardItemWire> }): void {
  const row = content.items.find((r) => r.id === rowId)! as MegaBoardRowWire;
  const col = row.items.find((c) => c.id === colId)! as MegaBoardColWire;
  if (!col.items) {
    col.items = [];
  }
  col.items.push(item as MegaBoardItemWire);
}

function removeItem(content: MegaBoardContentWire, { rowId, colId, itemId }: { rowId: string; colId: string; itemId: string }): void {
  const row = content.items.find((r) => r.id === rowId)! as MegaBoardRowWire;
  const col = row.items.find((c) => c.id === colId)! as MegaBoardColWire;
  Lodash.remove(col.items, (i) => i.id === itemId);
}

function moveItemPrev(content: MegaBoardContentWire, { rowId, colId, itemId }: { rowId: string; colId: string; itemId: string }): void {
  const row = content.items.find((r) => r.id === rowId)! as MegaBoardRowWire;
  const col = row.items.find((c) => c.id === colId)! as MegaBoardColWire;
  const index = col.items.findIndex((i) => i.id === itemId);
  if (index === 0) {
    return;
  }
  const temp = col.items[index - 1];
  col.items[index - 1] = col.items[index];
  col.items[index] = temp;
}

function moveItemNext(content: MegaBoardContentWire, { rowId, colId, itemId }: { rowId: string; colId: string; itemId: string }): void {
  const row = content.items.find((r) => r.id === rowId)! as MegaBoardRowWire;
  const col = row.items.find((c) => c.id === colId)! as MegaBoardColWire;
  const index = col.items.findIndex((i) => i.id === itemId);
  if (index === col.items.length - 1) {
    return;
  }
  const temp = col.items[index + 1];
  col.items[index + 1] = col.items[index];
  col.items[index] = temp;
}

export const MegaBoardContentWireFuncs = {
  starter,
  addRow,
  updateRow,
  removeRow,
  addCol,
  updateCol,
  removeCol,
  moveCol,
  addItem,
  removeItem,
  moveItemPrev,
  moveItemNext,
};
